import { PicPortfolio } from '../modules';

function PortfolioPage() {
  return (
    <main className="w-full">
      <PicPortfolio />
    </main>
  );
}

export default PortfolioPage;
